import script from "./BlockRecaptcha.vue?vue&type=script&setup=true&lang=js"
export * from "./BlockRecaptcha.vue?vue&type=script&setup=true&lang=js"

import "./BlockRecaptcha.vue?vue&type=style&index=0&id=6fccb080&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6fccb080"]])

export default __exports__